import axios from "axios";

export const botAperturas = async (negocios) => {
  let data = {
    negocios: negocios,
  };
  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API_URL_LOCAL_BOT}respuestas/aperturas`,
    data: data,
  };

  const resp = await axios(config)
    .then((response) => {
      return { ok: true, data: response.data };
    })
    .catch((error) => {
      console.log(error);
      return { ok: false, error: error.response.data };
    });
  return resp;
};
